<template>
    <div class="form-group" :class="{'has-error': error }">
        <label v-if="label" :for="name" class="label">{{ label }}</label>
        <div class="field-group">
            <div class="flex relative">
                <Icon v-if="isLoading" name="loader" class="absolute right-0 mt-3 mr-3 text-primary" />
                <vSelect
                    v-model="selected"
                    label="name"
                    :options="results"
                    :name="name"
                    @input="setProduct"
                    @search="searchProducts"
                    :searchable="true"
                    class="w-full"
                />
            </div>
            <Transition name="fade">
                <p v-show="error" class="error">{{ error }}</p>
            </Transition>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import debounce from 'lodash/debounce';
    import vSelect from 'vue-select';

    export default {
        name: 'SearchProductInput',
        components: {
            vSelect,
        },
        props: {
            preSelected: {
                type: Object,
                default: null,
            },
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: null,
            },
            error: {
                type: String,
                required: false,
                default: null,
            },
        },
        created() {
            this.selected = this.preSelected;
        },
        data() {
            return {
                isFocused: false,
                results: [],
                isLoading: false,
                selected: null,
            };
        },
        methods: {
            searchProducts(search, loading) {
                loading(true);
                this.search(loading, search, this);
            },

            search: debounce(async (loading, search, vm) => { // eslint-disable-line func-names
                vm.results = [];

                const { data } = await axios.get(window.route('api.products.search'), {
                    params: {
                        query: search,
                    },
                });

                loading(false);
                vm.results = data;
            }, 600),

            setProduct(product) {
                this.$emit('setProduct', product);
            },
        },
    };
</script>
